<script>
  import { operationStore, query } from "@urql/svelte";
  import { Starvortraege } from "../../Api/congress";
  import { IMSpezial } from "../../Api/congress";
  import { Teilnehmerkongresstermine } from "../../Api/congress";
  import OverviewKeynotespeaker from "./OverviewKeynotespeaker.svelte";
  import OverviewProgramBlock from "./OverviewProgramBlock.svelte";
  import OverviewProgramLunch from "./OverviewProgramLunch.svelte";
  import OverviewIMSpezial from "./OverviewIMSpezial.svelte";

  export let congressData;
  export let congressId;
  export let jumptoEventsPageTermin;

  const requestPolicy = "network-only";

  let eventProgramHours = [];
  for (let i = 8; i <= 20; i++) {
    eventProgramHours = [...eventProgramHours, i];
  }

  let keynotesspeaker = [];
  let imspezialStartday = 0;
  let imspezial = [];
  let teilnehmerkongresstermine = [];
  let hasModeratorTermin = false;

  let inProgressStarvortraege = false;

  const congressStarvortraege = operationStore(Starvortraege, { congressId }, { requestPolicy });

  query(congressStarvortraege);

  congressStarvortraege.subscribe((storeObjStarvortraege) => {
    inProgressStarvortraege = storeObjStarvortraege.fetching;
    if (!inProgressStarvortraege && storeObjStarvortraege.data) {
      keynotesspeaker = storeObjStarvortraege.data.starvortraegedata;
    }
  });

  let inProgressTeilnehmertermine = false;

  const congressTeilnehmertermine = operationStore(Teilnehmerkongresstermine, { congressId }, { requestPolicy });

  query(congressTeilnehmertermine);

  congressTeilnehmertermine.subscribe((storeObjTeilnehmertermine) => {
    inProgressTeilnehmertermine = storeObjTeilnehmertermine.fetching;
    if (!inProgressTeilnehmertermine && storeObjTeilnehmertermine.data) {
      teilnehmerkongresstermine = storeObjTeilnehmertermine.data.teilnehmerkongressterminedata;
      if (teilnehmerkongresstermine.teilnehmerIsModerator == 1) {
        hasModeratorTermin = true;
      }
    }
  });

  let inProgressSpezial = false;

  const congressIMSpezial = operationStore(IMSpezial, { congressId, action: "", actionVeranstaltungId: 0 }, { requestPolicy });

  query(congressIMSpezial);

  congressIMSpezial.subscribe((storeObjIMSpezial) => {
    inProgressSpezial = storeObjIMSpezial.fetching;
    if (!inProgressSpezial && storeObjIMSpezial.data) {
      imspezial = storeObjIMSpezial.data.imspezialdata;

      if (imspezial.startDate) {
        imspezial.startDateObj = new Date();
        imspezial.startDateObj.setTime(Date.parse(imspezial.startDate));
        imspezial.startDateFormated = imspezial.startDateObj.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });

        imspezialStartday = imspezial.startDateObj.toLocaleDateString("de-DE", { day: "2-digit" });
      }

      imspezial.eventDates = [];
      imspezial.eventsKeyed = [];

      imspezial.eventlist.forEach(function (myEvent) {
        if (imspezial.eventDates.indexOf(myEvent.startDate + "#" + myEvent.startTime) == -1) {
          imspezial.eventDates.push(myEvent.startDate + "#" + myEvent.startTime);
          imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime] = {
            startDateFormated: "",
            dayNumber: 0,
            startDateObj: null,
            startTime: myEvent.startTime,
            endTime: myEvent.endTime,
            eventlist: [],
          };

          imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateObj = new Date();
          imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateObj.setTime(Date.parse(myEvent.startDate));
          imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateFormated = imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateObj.toLocaleDateString(
            "de-DE",
            { day: "2-digit", month: "long", year: "numeric" },
          );
          imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateFormated2 = imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateObj.toLocaleDateString(
            "de-DE",
            { day: "numeric", month: "long", year: "numeric" },
          );

          if (imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].startDateFormated2 == imspezial.congressDay2 + ". " + imspezial.congressMonth2 + " " + imspezial.congressYear) {
            imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].dayNumber = 2;
          } else {
            imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].dayNumber = 1;
          }
        }
        imspezial.eventsKeyed[myEvent.startDate + "#" + myEvent.startTime].eventlist.push(myEvent);
      });
    }
  });
</script>

<div class="flex w-full flex-wrap">
  <div class="w-1/5 lg:w-1/5">
    <p class="mb-2">
      <svg class="svg-inline--fa fa-sm" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
        ><path
          d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        ></path></svg
      > Zeit
    </p>
    <ul class="last-child:mb-4 not-prose *:h-[30px] *:border-t *:border-t-slate-200 *:text-xs *:font-bold">
      {#each eventProgramHours as item}
        <li class="!border-t-2 !border-slate-400">{item < 10 ? "0" : ""}{item}:00 Uhr</li>
        <li aria-hidden="true">&nbsp;</li>
        <li aria-hidden="true">&nbsp;</li>
        {#if !item.isLast}
          <li class="!border-t-2 !border-t-slate-300">{item < 10 ? "0" : ""}{item}:30 Uhr</li>
          <li aria-hidden="true">&nbsp;</li>
          <li aria-hidden="true">&nbsp;</li>
        {/if}
      {/each}
    </ul>
  </div>
  <div class="relative w-4/5 lg:w-2/5" id="day1">
    <p class="mb-2">
      <svg class="svg-inline--fa fa-sm" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
        ><path
          d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"
        ></path></svg
      >
      {congressData.congressDay1}. {congressData.congressMonth1}
      {congressData.congressYear}
    </p>
    <div class="relative set-start-time-8">
      <ul class="last-child:mb-4 not-prose bg-gray-200/75 *:h-[30px] *:border-t *:border-t-white">
        {#each eventProgramHours as item}
          <li aria-hidden="true" class="!border-t-2 !border-slate-400">&nbsp;</li>
          <li aria-hidden="true">&nbsp;</li>
          <li aria-hidden="true">&nbsp;</li>
          {#if !item.isLast}
            <li aria-hidden="true" class="!border-t-2 !border-t-slate-300">&nbsp;</li>
            <li aria-hidden="true">&nbsp;</li>
            <li aria-hidden="true">&nbsp;</li>
          {/if}
        {/each}
      </ul>

      <OverviewProgramLunch displayTimeString="13:00-14:25 Uhr" starttimeMinutes="780" durationMinutes="85"></OverviewProgramLunch>

      {#each keynotesspeaker?.eventlist || [] as item}
        {#if item.startDate.substring(0, 2) == congressData.congressDay1}
          <OverviewKeynotespeaker {item}></OverviewKeynotespeaker>
        {/if}
      {/each}

      {#each imspezial?.eventDates || [] as eventDatetime}
        {#if imspezial?.eventsKeyed[eventDatetime].startDateFormated2 == congressData.congressDay1 + ". " + congressData.congressMonth1 + " " + congressData.congressYear}
          <OverviewIMSpezial imspezial={imspezial?.eventsKeyed[eventDatetime]}></OverviewIMSpezial>
        {/if}
      {/each}

      {#each teilnehmerkongresstermine?.eventlistModerator || [] as item}
        {#if item.startDate.substring(0, 2) == congressData.congressDay1}
          <OverviewProgramBlock {item} {jumptoEventsPageTermin} moderator={true}></OverviewProgramBlock>
        {/if}
      {/each}

      {#each teilnehmerkongresstermine?.eventlistReserved || [] as item}
        {#if item.startDate.substring(0, 2) == congressData.congressDay1}
          <OverviewProgramBlock {item} {jumptoEventsPageTermin} moderator={false}></OverviewProgramBlock>
        {/if}
      {/each}
    </div>
  </div>
  <div class="mt-4 block w-1/5 lg:mt-0 lg:hidden">
    <p class="mb-2">
      <svg xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 512 512"
        ><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.--><path
          d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        /></svg
      >
      {" "} Zeit
    </p>
    <ul class="last-child:mb-4 not-prose *:h-[30px] *:border-t *:border-t-slate-200 *:text-xs *:font-bold">
      {#each eventProgramHours as item}
        <li class="!border-t-2 !border-slate-400">{item < 10 ? "0" : ""}{item}:00 Uhr</li>
        <li aria-hidden="true">&nbsp;</li>
        <li aria-hidden="true">&nbsp;</li>
        {#if !item.isLast}
          <li class="!border-t-2 !border-t-slate-300">{item < 10 ? "0" : ""}{item}:30 Uhr</li>
          <li aria-hidden="true">&nbsp;</li>
          <li aria-hidden="true">&nbsp;</li>
        {/if}
      {/each}
    </ul>
  </div>
  <div class="relative mt-4 w-4/5 lg:mt-0 lg:w-2/5" id="day2">
    <p class="mb-2">
      <svg class="svg-inline--fa fa-sm" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
        ><path
          d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"
        ></path></svg
      >
      {congressData.congressDay2}. {congressData.congressMonth2}
      {congressData.congressYear}
    </p>
    <div class="relative set-start-time-8">
      <ul class="last-child:mb-4 not-prose bg-gray-300/75 *:h-[30px] *:border-t *:border-t-white">
        {#each eventProgramHours as item}
          <li aria-hidden="true" class="!border-t-2 !border-slate-400">&nbsp;</li>
          <li aria-hidden="true">&nbsp;</li>
          <li aria-hidden="true">&nbsp;</li>
          {#if !item.isLast}
            <li aria-hidden="true" class="!border-t-2 !border-t-slate-300">&nbsp;</li>
            <li aria-hidden="true">&nbsp;</li>
            <li aria-hidden="true">&nbsp;</li>
          {/if}
        {/each}
      </ul>

      <OverviewProgramLunch displayTimeString="12:45-14:15 Uhr" starttimeMinutes="765" durationMinutes="90"></OverviewProgramLunch>

      {#each keynotesspeaker?.eventlist || [] as item}
        {#if item.startDate.substring(0, 2) == congressData.congressDay2}
          <OverviewKeynotespeaker {item}></OverviewKeynotespeaker>
        {/if}
      {/each}

      {#each imspezial?.eventDates || [] as eventDatetime}
        {#if imspezial?.eventsKeyed[eventDatetime].startDateFormated2 == congressData.congressDay2 + ". " + congressData.congressMonth2 + " " + congressData.congressYear}
          <OverviewIMSpezial imspezial={imspezial?.eventsKeyed[eventDatetime]}></OverviewIMSpezial>
        {/if}
      {/each}

      {#each teilnehmerkongresstermine?.eventlistModerator || [] as item}
        {#if item.startDate.substring(0, 2) == congressData.congressDay2}
          <OverviewProgramBlock {item} moderator={true} {jumptoEventsPageTermin}></OverviewProgramBlock>
        {/if}
      {/each}

      {#each teilnehmerkongresstermine?.eventlistReserved || [] as item}
        {#if item.startDate.substring(0, 2) == congressData.congressDay2}
          <OverviewProgramBlock {item} moderator={false} {jumptoEventsPageTermin}></OverviewProgramBlock>
        {/if}
      {/each}
    </div>
  </div>
</div>
